import React from "react"
import { useIsManager } from "app/components/AccessRoles/useAccessRoles"
import { Redirect, Switch } from "react-router-dom"
import AppRoute from "./AppRoute"
import { RouteObject } from "."

interface IAppRoutesProps {
  children?: React.ReactNode
  routes: RouteObject[]
}
const AppRoutes: React.FC<IAppRoutesProps> = ({ children, routes }) => {
  const { isAllowed: isManager, hasUserAndToken } = useIsManager()
  const toRoute = !isManager ? "/personal-planning" : "/planning"
  return (
    <Switch>
      {hasUserAndToken && <Redirect exact={true} key="/" from="/" to={toRoute} />}
      {routes.map(route => (
        <AppRoute key={route.path} {...route} />
      ))}
      {children}
    </Switch>
  )
}

export default AppRoutes
